
import { Device } from '@/store/types'
import { Vue, Options } from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import { Getter } from 'vuex-class'

@Options({})
export default class PopModal extends Vue {
    @Prop({ default: false })
    isOpen!: boolean

    @Getter('device') device!: Device

    isClosing = false

    $emit!: Vue['$emit']

    mounted(): void {
        console.log('PopModal mounted')
    }

    async handleClose() {
        this.isClosing = true
        await new Promise(resolve => setTimeout(resolve, 500))
        this.isClosing = false
        this.$emit('close')
    }

    openLink() {
        window.open('https://hq6868.info/', '_blank')
    }
}
